import {Injectable} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {CustomModalComponent} from '../../views/common/components/modals/custom-modal/custom-modal.component';
import {CustomModalModel} from '../../core-logic/models/custom-modal/custom-modal-model';
import * as _ from 'lodash';
import {from, Observable, of, Subject} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {
  ActivateNotificationsModalComponent
} from '../../views/common/components/modals/activate-notifications-modal/activate-notifications-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private readonly defaultModalModel: CustomModalModel = {
    title: '',
    message: { value: '' },
    cancel_button: {
      label: 'Annuler',
      visible: true
    },
    validate_button: {
      label: 'Valider',
      visible: true
    },
    close_button: {
      visible: true
    },
    disable_close: false
  };

  private modalSubject: Subject<boolean> = new Subject<boolean>()
  constructor(private modalCtrl: ModalController) {}

  createCustomModal(customModalModel: CustomModalModel): Observable<boolean> {
    customModalModel = _.merge(_.cloneDeep(this.defaultModalModel), customModalModel)
    from(this.modalCtrl.create({ component: CustomModalComponent, componentProps: { customModalModel }, backdropDismiss: !customModalModel.disable_close}))
      .pipe(switchMap(customModal =>  {
        from(customModal.onWillDismiss()).subscribe(modalAction => {
          if (!_.isUndefined(modalAction.data?.validate)) { this.modalSubject.next(modalAction.data?.validate); }
        });
        return of(customModal);
      }))
      .pipe(
        map(customModal => from(customModal.present()))
      ).subscribe()

    return this.modalSubject.asObservable();
  }

  createModal(type: 'activate-notifications'): Observable<boolean> {
    switch (type) {
      case 'activate-notifications':
        from(this.modalCtrl.create({ component: ActivateNotificationsModalComponent}))
          .pipe(
            switchMap(createdModal => {
              from(createdModal.onWillDismiss()).subscribe(modalAction => {
                if (!_.isUndefined(modalAction.data?.validate)) { this.modalSubject.next(modalAction.data?.validate); }
              });
              return of(createdModal);
            })
          )
          .subscribe(modal => modal.present());
        return this.modalSubject.asObservable();
    }
  }
}

/*
subscribe(customModal => {
        this.customModal = customModal;

      })
 */

/*    const customModalModel: CustomModalModel = {
      title: 'Hello word',
      message: {value: '<p> im a boss </p> <br> <a href="https://www.fydl-app.com"> link</a>', type: ModalMessageType.HTML },
    };
    this.customModalService.create(customModalModel).then(final => console.log('final ' + final));*/
